import React, { useContext } from 'react';
import {
  View, StyleSheet, Platform, Animated,
} from 'react-native';
import LottieView from 'lottie-react-native';

import { useColors } from '../../contexts/theme';
import { ScrollViewContext } from '../DraggableFlatList/contexts/ScrollViewContext';
import { DraggableFlatListContext } from '../DraggableFlatList/contexts/DraggableFlatListContext';
import overscrollLottie from '../../resources/lottie/3442-scroll.json';


const styles = StyleSheet.create({
  footer: {
    flex: 1,
  },
  lottie: {

  },
  animatedView: {
    flex: 1,
    paddingBottom: 150,
  },
});

const interpolations = {
  opacity: {
    inputRange: [0, 10, 45, 50],
    outputRange: [0, 0.5, 0.5, 1],
    extrapolate: 'clamp',
  },
  progress: {
    inputRange: [10, 50],
    outputRange: [0.555, 0.61],
    extrapolate: 'clamp',
  },
  scale: {
    inputRange: [50, 100],
    outputRange: [1, 2],
    extrapolate: 'clamp',
  },
};

const ListFooter = ({ children }) => {
  const {
          contentSize,
          layout,
        } = useContext(ScrollViewContext),
        {
          scrollContentOffsetY,
        } = useContext(DraggableFlatListContext),
        colors = useColors();

  const progress = Animated.add(
    new Animated.Value(-contentSize.height),
    Animated.add(
      scrollContentOffsetY.current,
      new Animated.Value(layout.height),
    ),
  );

  return (
    <View style={styles.footer}>
      <View style={{ backgroundColor: colors.separator }}>
        { children }
      </View>
      <Animated.View style={[
        styles.animatedView,
        {
          opacity: progress.interpolate(interpolations.opacity),
          transform: [{
            scale: progress.interpolate(interpolations.scale),
          }],
        }]}
      >
        {Platform.OS === 'ios' ? (
          <LottieView
            progress={progress.interpolate(interpolations.progress)}
            style={styles.lottie}
            source={overscrollLottie}
            colorFilters={[{
              keypath: 'arrow',
              color: colors.separator,
            }]}
          />
        ) : null }
      </Animated.View>
    </View>
  );
};

ListFooter.whyDidYouRender = {
  logOnDifferentValues: true,
  customName: 'EnhancedMenu',
};

export default React.memo(ListFooter);
